export const GTM_EVENTS = {
  // Authentication
  LOGIN: 'login',
  SIGNUP: 'sign_up',

  // Trip Designer
  TRIP_CREATED: 'trip_created',
  TRIP_OPENED: 'trip_opened',
  TRIP_SAVED_DRAFT: 'trip_saved_draft',
  TRIP_SAVED_TEMPLATE: 'trip_saved_template',

  // Trip composition
  EXPERIENCE_ADDED: 'experience_added',
  EXPERIENCE_REMOVED: 'experience_removed',
  HOTEL_ADDED: 'hotel_added',
  HOTEL_REMOVED: 'hotel_removed',
  HOTEL_BOOK_ON_MY_OWN: 'hotel_book_on_my_own',

  // Booking
  BOOKING_STARTED: 'booking_started',

  // Checkout steps
  CHECKOUT_ROOMS_SELECTED: 'checkout_rooms_selected',
  CHECKOUT_ROOMS_CONFIRMED: 'checkout_rooms_confirmed',
  CHECKOUT_TRAVELERS_FILLED: 'checkout_travelers_filled',
  CHECKOUT_SUBMITTED: 'checkout_submitted',
  CHECKOUT_COMPLETED: 'checkout_completed',

  // Errors
  ERROR_TRIP_CREATION: 'error_trip_creation',
  ERROR_BOOKING_HOTEL: 'error_booking_hotel',
  ERROR_BOOKING_EXPERIENCE: 'error_booking_experience',
};

export const TRIP_ORIGINS = {
  SCRATCH: 'scratch',
  TEMPLATE: 'template',
  DRAFT: 'draft',
  TRIP: 'trip',
};
